<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        data-url="/accreditations/certificationActivities"
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label
                >Países en los que el organismo solicitante emite o tiene
                previsto emitir certificados</label
              >
              <app-input
                type="textarea"
                v-model="inputs.activity.countries_issues_certificates"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <label>Número de certificados emitidos por país</label>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">País</th>
                  <th scope="col">Nº certificados</th>
                  <th scope="col" class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="addElement()"
                    >
                      <app-icon name="plus" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, index) in inputs.certificates_issued"
                  :key="index"
                >
                  <td>
                    <app-input
                      type="text"
                      v-model="value.country"
                      placeholder="Ingrese el país"
                      :required="true"
                    />
                  </td>
                  <td>
                    <app-input
                      type="number"
                      v-model="value.number_certificates"
                      placeholder="Ingrese el nº certificados"
                      :required="true"
                    />
                  </td>
                  <td class="text-center">
                    <button
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="deleteElement(index)"
                    >
                      <app-icon name="trash-2" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label
                >Países en los que el organismo solicitante opera desde una
                ubicación fija que realiza alguna actividad de
                certificación</label
              >
              <app-input
                type="textarea"
                v-model="
                  inputs.activity.countries_certification_activities_fixed
                "
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label
                >Países en los que el organismo solicitante tiene personal
                remoto que realiza(rá) alguna actividad de certificación</label
              >
              <app-input
                type="textarea"
                v-model="
                  inputs.activity.countries_certification_activities_remote
                "
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label
                >Países en los que el organismo solicitante tiene acuerdos para
                gestionar las actividades que se realizan desde oficinas fijas
                extranjeras o que realiza personal remoto: (***)</label
              >
              <app-input
                type="textarea"
                v-model="
                  inputs.activity
                    .countries_certification_activities_fixed_remote
                "
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        activity: {},
        certificates_issued: [],
      },
      modalId: "add-edit-modal",
      disabledSubmit: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.activity.acc_app_id = this.$store.state.accreditation.id;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.activity.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs.activity = response.data;
      this.inputs.certificates_issued = response.data.certificates_issued;
      this.preloader = false;
    },

    addElement() {
      this.inputs.certificates_issued.push({
        id: null,
        cert_act_id: null,
        country: null,
        number_certificates: null,
      });
    },

    deleteElement(index) {
      const tmp = this.inputs.certificates_issued.filter(
        (item, i) => index != i
      );
      this.$set(this.inputs, "certificates_issued", tmp);
    },
  },
};
</script>
